import { QcSeriesDescription } from '@common/config/api/client'
import { RemoveRedEyeRounded } from '@mui/icons-material'
import { IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { SIZING } from '@common/theme/sizing'
import { launchDicomViewerForQC } from '@common/utils/ohifUtils'
import { useParams } from 'react-router-dom'
import { useExtendedAuth } from '@auth/hooks/useExtendedAuth'
import Toast from '@common/components/Toast/Toast'
import { toast } from 'sonner'
import StudySeriesTableHeader from './StudySeriesTableHeader'

export default function StudySeriesTable({ seriesDescription }: { seriesDescription: QcSeriesDescription }) {
  const { qcTaskId, studyId } = useParams()
  const { user } = useExtendedAuth()

  const series = {
    description: seriesDescription.series_label_name || '',
    series_number: seriesDescription.series_number || 0,
    acquisition_date: seriesDescription.acquisition_date || '',
    total_instances: seriesDescription.instance_number_ranges.reduce(
      (total, range) => total + ((range.end || 0) - (range.start || 0)),
      0,
    ),
    series_uid: seriesDescription.submission_series_id,
    series_metadata_id: seriesDescription.submission_series_id,
  }

  const allSeries = [series]

  return (
    <TableContainer
      sx={{
        borderRadius: SPACING.borderRadiusXl,
      }}
    >
      <Stack spacing={SPACING.minSpacing}>
        <Table size="small">
          <StudySeriesTableHeader />
          <TableBody>
            {allSeries.map((series, index) => {
              return (
                <TableRow key={index}>
                  <TableCell>{series.description}</TableCell>
                  <TableCell>{series.series_number}</TableCell>
                  <TableCell>{series.acquisition_date}</TableCell>
                  <TableCell>{series.total_instances}</TableCell>
                  <TableCell align="right">
                    <IconButton
                      onClick={() => {
                        if (qcTaskId) {
                          if (!studyId || !user?.access_token) {
                            toast(
                              <Toast
                                message="Missing required parameters for QC task. Please ensure study ID and authentication token are provided."
                                variant="error"
                              />,
                            )
                            return false
                          }
                          // Note: series.series_uid here is submission_series_id (a DB row UUID),
                          // NOT a DICOM SeriesInstanceUID, so it cannot be used to restrict the
                          // OHIF study browser to a single series (see StudySeriesTable review).
                          launchDicomViewerForQC(studyId, qcTaskId, user.access_token, series.series_uid || undefined)
                        }
                      }}
                    >
                      <RemoveRedEyeRounded
                        sx={{
                          color: 'text.secondary',
                          width: SIZING.iconWidth,
                          height: SIZING.iconWidth,
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Stack>
    </TableContainer>
  )
}
